import axios, { AxiosResponse } from 'axios'
import {
  AfericaoDispositivoResumo,
  AfericoesQueryResponse,
  AlocacaoDispositivoList,
  DispositivoGestaoDto,
  DispositivoGestaoView,
  DispositivosGestaoQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
export const DISPOSITIVOS_URL = `${API_URL}/dispositivos`
const GESTAO_URL = `${DISPOSITIVOS_URL}/gestao`

/** Listagem da gestão: filtros no `search` (DSL); `telekit` e `alocavel` como parâmetros. */
export const getDispositivosGestao = (query: string): Promise<DispositivosGestaoQueryResponse> =>
  axios
    .get(`${GESTAO_URL}?${query}`)
    .then((resp: AxiosResponse<DispositivosGestaoQueryResponse>) => resp.data)

export const getDispositivoGestao = (id: number): Promise<DispositivoGestaoView> =>
  axios.get(`${GESTAO_URL}/${id}`).then((resp: AxiosResponse<DispositivoGestaoView>) => resp.data)

export const createDispositivoGestao = (
  dto: DispositivoGestaoDto
): Promise<DispositivoGestaoView> =>
  axios.post(GESTAO_URL, dto).then((resp: AxiosResponse<DispositivoGestaoView>) => resp.data)

/** Sempre com o objeto completo: no PUT de gestão, campo ausente limpa o valor salvo. */
export const updateDispositivoGestao = (
  id: number,
  dto: DispositivoGestaoDto
): Promise<DispositivoGestaoView> =>
  axios
    .put(`${GESTAO_URL}/${id}`, { ...dto, id })
    .then((resp: AxiosResponse<DispositivoGestaoView>) => resp.data)

/** Histórico de alocações do aparelho, `dtInicio` desc, sem paginação. */
export const getAlocacoesDispositivo = (id: number): Promise<AlocacaoDispositivoList[]> =>
  axios
    .get(`${DISPOSITIVOS_URL}/${id}/alocacoes`)
    .then((resp: AxiosResponse<AlocacaoDispositivoList[]>) => resp.data)

export const getAfericoesResumo = (id: number): Promise<AfericaoDispositivoResumo> =>
  axios
    .get(`${GESTAO_URL}/${id}/afericoes/resumo`)
    .then((resp: AxiosResponse<AfericaoDispositivoResumo>) => resp.data)

export const getAfericoes = (id: number, query: string): Promise<AfericoesQueryResponse> =>
  axios
    .get(`${GESTAO_URL}/${id}/afericoes?${query}`)
    .then((resp: AxiosResponse<AfericoesQueryResponse>) => resp.data)
